<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew blue">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3  text-white">A beautiful System
                                    <span>with all my projects</span>
                                </h1>
                                <p class="lead  text-white">Designed with Vue.js and integrated with Github and Medium. To synchronize everything in a friendly way to be analyzed.</p>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        <section class="section section-lg pt-lg-0 mt--200">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-tv-2" type="primary" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-primary text-uppercase">FrontEnd</h6>
                                    <p class="description mt-3">With projects developed in Vue.js and React</p>
                                    <div>
                                        <badge type="primary" rounded>Vue.js</badge>
                                        <badge type="primary" rounded>React</badge>
                                        <badge type="primary" rounded>CSS3</badge>
                                    </div>
                                    <base-button tag="a" href="#/projects?tags=frontend" type="primary" class="mt-4">
                                        Learn more
                                    </base-button>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-app" type="success" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-success text-uppercase">BackEnd</h6>
                                    <p class="description mt-3">Incredible projects developed in Laravel, Node and Python</p>
                                    <div>
                                        <badge type="success" rounded>Laravel</badge>
                                        <badge type="success" rounded>Node</badge>
                                        <badge type="success" rounded>Python</badge>
                                    </div>
                                    <base-button tag="a" href="#/projects?tags=backend" type="success" class="mt-4">
                                        Learn more
                                    </base-button>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" hover shadow body-classes="py-5">
                                    <icon name="ni ni-bulb-61" type="warning" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-warning text-uppercase">AI</h6>
                                    <p class="description mt-3">Amazing AI solutions developed to predict, clustering and solve hard problems</p>
                                    <div>
                                        <badge type="warning" rounded>AI</badge>
                                        <badge type="warning" rounded>Python</badge>
                                        <badge type="warning" rounded>Machine Learning</badge>
                                    </div>
                                    <base-button tag="a" href="#/projects?tags=ai" type="warning" class="mt-4">
                                        Learn more
                                    </base-button>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-lg">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-md-2">
                        <img src="img/theme/frontend-sec.jpg" class="img-fluid floating">
                    </div>
                    <div class="col-md-6 order-md-1">
                        <div class="pr-md-5">
                            <icon name="ni ni-tv-2" class="mb-5" size="lg" type="primary" shadow
                                  rounded></icon>
                            <h3>FrontEnd</h3>
                            <p>Nice solutions and beautiful layouts developed to make the UX the better.</p>
                            <ul class="list-unstyled mt-5">
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="primary" circle class="mr-3" icon="ni ni-settings-gear-65"></badge>
                                        <h6 class="mb-0">Carefully crafted intuitive flows applying Data Visualization best practices</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="primary" circle class="mr-3" icon="ni ni-html5"></badge>
                                        <h6 class="mb-0">Amazing HTML and CSS3 effects</h6>
                                    </div>
                                </li>
                                <li class="py-2">
                                    <div class="d-flex align-items-center">
                                        <badge type="primary" circle class="mr-3" icon="ni ni-satisfied"></badge>
                                        <h6 class="mb-0">Super friendly design</h6>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container">
            <div class="row row-grid align-items-center">
              <div class="col-md-6 order-md-2">
                <img src="img/theme/backend-sec.jpg" class="img-fluid floating">
              </div>
              <div class="col-md-6 order-md-1">
                <div class="pr-md-5">
                  <icon name="ni ni-app" class="mb-5" size="lg" type="success" shadow
                        rounded></icon>
                  <h3>BackEnd</h3>
                  <p>Powerful solutions for large data processing. I built the <a target="_blank" href="https://exatosolucoes.com.br/#slide2">Exato GC</a> that reconciled more than BRL 1 billion. I also participated in the development of
                    <a target="_blank" href="https://www.hotmilhas.com.br/">HotMilhas 2.0</a>. Largest air miles sales system in Latin America.</p>
                  <ul class="list-unstyled mt-5">
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge type="success" circle class="mr-3" icon="ni ni-vector"></badge>
                        <h6 class="mb-0">Structured microservices for good integration</h6>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge type="success" circle class="mr-3" icon="ni ni-ui-04"></badge>
                        <h6 class="mb-0">Quality and fast API's</h6>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge type="success" circle class="mr-3" icon="ni ni-delivery-fast"></badge>
                        <h6 class="mb-0">High productivity</h6>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="section bg-secondary">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6">
                        <div class="card bg-default shadow border-0">
                            <img v-lazy="'img/theme/img-1-1200x1000.jpg'" class="card-img-top">
                            <blockquote class="card-blockquote">
                                <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                     class="svg-bg">
                                    <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                                    <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
                                </svg>
                                <h4 class="display-3 font-weight-bold text-white">AI</h4>
                                <p class="lead text-italic text-white">With the advancement of technologies, solutions increasingly become more complex.</p>
                            </blockquote>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="pl-md-5">
                            <icon name="ni ni-bulb-61" class="mb-5" size="lg" type="warning" shadow rounded></icon>

                            <h3>The best tool</h3>
                            <p class="lead">The automation of specialist tasks that previously could only be done by very well trained professionals.</p>
                            <p>Today they can be directed and trained for algorithms that have greater precision and agility.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>


    </div>
</template>

<script>
export default {
  name: "home",
  components: {}
};
</script>
<style lang="scss">
  .blue {
    background: linear-gradient(150deg, #034aba 15%, #9c80d4 70%, #02f5fe 94%) !important;
  }
</style>
